import React, { useState } from "react";
import "./MyRequestsPage.css";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";
import RequestDetailModal from "../../components/RequestDetailModal/RequestDetailModal";
registerLocale("vi", vi);
const MyRequestsPage = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedReq, setSelectedReq] = useState(null);
  const [filters, setFilters] = useState({
    loaiYeuCau: "",
    trangThai: "",
    fromDate: "",
    toDate: "",
  });

  const data = [
    {
      time: "2025-03-05 09:00:00",
      user: "lansn",
      chinhanh: "069",
      loaiGD: "Đóng",
      loaiYC: "Đại lý",
      idDLTT: "ID-00001234-068-001",
      cifDLTT: "00007899",
      tenDLTT: "Đại lý Thanh toán Như Ý",
      trangThai: "Chờ duyệt",
      tktt: "4444444444",
    },
    {
      time: "Content",
      user: "Content",
      chinhanh: "Content",
      loaiGD: "Tạm khóa",
      loaiYC: "Nhân viên",
      idDLTT: "Content",
      cifDLTT: "Content",
      tenDLTT: "Content",
      trangThai: "Đã duyệt",
      tktt: "Content",
    },
    {
      time: "Content",
      user: "Content",
      chinhanh: "Content",
      loaiGD: "Tạo mới",
      loaiYC: "Nhân viên",
      idDLTT: "Content",
      cifDLTT: "Content",
      tenDLTT: "Content",
      trangThai: "Từ chối",
      tktt: "Content",
    },
    {
      time: "Content",
      user: "Content",
      chinhanh: "Content",
      loaiGD: "Chỉnh sửa",
      loaiYC: "Nhân viên",
      idDLTT: "Content",
      cifDLTT: "Content",
      tenDLTT: "Content",
      trangThai: "Content",
      tktt: "Content",
    },
  ];

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  // Hàm xử lý riêng cho DatePicker để cập nhật vào state filters
  const handleDateChange = (date, name) => {
    // Nếu bạn muốn lưu dạng string 'YYYY-MM-DD' vào state thì cần format lại, 
    // còn nếu state lưu object Date thì cứ để nguyên 'date'.
    // Ở đây mình giả định bạn cập nhật state như bình thường:

    // Ví dụ cập nhật state:
    setFilters(prev => ({ ...prev, [name]: date }));

    // *Lưu ý: Bạn cần sửa lại hàm handleChange của bạn hoặc dùng trực tiếp setFilters tại đây
  };
  const handleSearch = () => console.log(filters);
  const handleReset = () => setFilters({ loaiYeuCau: "", trangThai: "", fromDate: "", toDate: "" });

  return (
    <div className="my-req-container">
      <h2 className="page-title">Yêu cầu của tôi</h2>

      {/* FORM */}
      <div className="req-filter-card">
        <div className="req-grid">
          <div className="req-item">
            <label>Loại yêu cầu</label>
            <select name="loaiYeuCau" value={filters.loaiYeuCau} onChange={handleChange}>
              <option value="">Chọn loại yêu cầu</option>
              <option value="dong">Đóng</option>
              <option value="tamkhoa">Tạm khóa</option>
            </select>
          </div>

          <div className="req-item">
            <label>Trạng thái</label>
            <select name="trangThai" value={filters.trangThai} onChange={handleChange}>
              <option value="">Tất cả</option>
              <option value="choduyet">Chờ duyệt</option>
              <option value="daduyet">Đã duyệt</option>
              <option value="tuchoi">Từ chối</option>
            </select>
          </div>

          {/* --- TỪ NGÀY --- */}
          <div className="req-item">
            <label>Từ ngày (From Date)</label>
            <div className="date-wrapper">
              <img src="/icons/icons8-calendar-100.png" alt="" className="date-icon"
              />

              <DatePicker
                selected={filters.fromDate ? new Date(filters.fromDate) : null} // Chuyển đổi string sang Date
                onChange={(date) => handleDateChange(date, "fromDate")} // Gọi hàm cập nhật state
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                locale="vi"
                className="custom-datepicker-input" // Class để style CSS
                popperPlacement="bottom-start" // QUAN TRỌNG: Giữ lịch nằm ngay dưới input
              />
            </div>
          </div>

          {/* --- ĐẾN NGÀY --- */}
          <div className="req-item">
            <label>Đến ngày (To Date)</label>
            <div className="date-wrapper">
              <img src="/icons/icons8-calendar-100.png" alt="" className="date-icon" />

              <DatePicker
                selected={filters.toDate ? new Date(filters.toDate) : null}
                onChange={(date) => handleDateChange(date, "toDate")}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                locale="vi"
                className="custom-datepicker-input"
                popperPlacement="bottom-start" // QUAN TRỌNG: Giữ lịch nằm ngay dưới input
              />
            </div>
          </div>
        </div>

        <div className="req-actions">
          <button className="btn-secondary" onClick={handleReset}>Xóa lọc</button>
          <button className="btn-primary" onClick={handleSearch}>Tìm kiếm</button>
        </div>
      </div>

      {/* KẾT QUẢ */}
      <div className="req-result-header">
        <h3 className="result-title">Kết quả tìm kiếm</h3>
        <div className="search-inline">
          <img src="/icons/icons8-search-100.png" className="search-icon" />
          <input type="text" placeholder="Tìm kiếm nhanh trong bảng..." />
        </div>
      </div>

      {/* TABLE */}
      <div className="req-table-wrapper">
        <table className="req-table">
          <thead>
            <tr>
              <th>Thao tác</th>
              <th>Thời gian tạo</th>
              <th>User tạo</th>
              <th>Chi nhánh</th>
              <th>Loại giao dịch</th>
              <th>Loại yêu cầu</th>
              <th>ID ĐLTT/User</th>
              <th>CIF ĐLTT</th>
              <th>Tên ĐLTT</th>
              <th>Trạng thái</th>
              <th>TKTT giao dịch</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                <td><img src="/icons/icons8-eye-100.png" className="eye-icon" onClick={() => {
                  setSelectedReq(row);
                  setOpenDetail(true);
                }} /></td>
                <td>{row.time}</td>
                <td>{row.user}</td>
                <td>{row.chinhanh}</td>
                <td>{row.loaiGD}</td>
                <td>{row.loaiYC}</td>
                <td>{row.idDLTT}</td>
                <td>{row.cifDLTT}</td>
                <td>{row.tenDLTT}</td>
                <td>{row.trangThai}</td>
                <td>{row.tktt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="pagination">
        <span>Số lượng bản ghi: 4/10 (trên 10 bản ghi/trang)</span>
        <div className="pager">
          <button disabled>Trước</button>
          <button className="active">1</button>
          <button>Sau</button>
        </div>
      </div>
      <RequestDetailModal
        open={openDetail}
        onClose={() => setOpenDetail(false)}
        data={selectedReq}
      />

    </div>
  );
};

export default MyRequestsPage;
